// API contract package. openapi.yaml is the single source of truth for the
// REST API; ws-messages.schema.json (generated from it) describes realtime
// WebSocket frames. src/generated/openapi.ts holds the types generated from
// the spec (`pnpm codegen`); requests go through openapi-fetch.
import createClient, {} from "openapi-fetch";
export const API_VERSION = "0.1.0";
/** Typed REST client; `baseUrl` is the server origin plus `/api/v1`. */
export function createApiClient(options) {
    return createClient(options);
}
//# sourceMappingURL=index.js.map